var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.5C0 4.98583 4.48583 0.5 10 0.5C15.5137 0.5 20 4.98583 20 10.5C20 16.0142 15.5137 20.5 10 20.5C4.48583 20.5 0 16.0142 0 10.5ZM1.66667 10.5C1.66667 15.095 5.405 18.8333 10 18.8333C14.595 18.8333 18.3333 15.095 18.3333 10.5C18.3333 5.905 14.595 2.16667 10 2.16667C5.405 2.16667 1.66667 5.905 1.66667 10.5ZM11.1785 10.5L12.9463 12.2678C13.2715 12.593 13.2715 13.121 12.9463 13.4463C12.621 13.7715 12.093 13.7715 11.7678 13.4463L10 11.6785L8.23223 13.4463C7.90696 13.7715 7.37899 13.7715 7.05372 13.4463C6.72845 13.121 6.72845 12.593 7.05372 12.2678L8.82149 10.5L7.05372 8.73223C6.72845 8.40696 6.72845 7.87898 7.05372 7.55372C7.37899 7.22845 7.90696 7.22845 8.23223 7.55372L10 9.32148L11.7678 7.55372C12.093 7.22845 12.621 7.22845 12.9463 7.55372C13.2715 7.87898 13.2715 8.40696 12.9463 8.73223L11.1785 10.5Z",
    fill: "#F0AB2E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.46c94e00.svg";
export { ForwardRef as ReactComponent };